<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import Vue from 'vue';
export default {
  name: 'App',
  data() {
    return {
      currentLang: this.getLangFromRoute(this.$route.path)
    };
  },
  watch: {
    '$route'(to) {
      this.currentLang = this.getLangFromRoute(to.path);
    }
  },
  methods: {
    getLangFromRoute(path) {
      if (path.indexOf('/en') !== -1) return 'en';
      if (path.indexOf('/fr') !== -1) return 'fr';
      if (path.indexOf('/de') !== -1) return 'de';
      if (path.indexOf('/es') !== -1) return 'es';
      if (path.indexOf('/pt') !== -1) return 'pt';
      if (path.indexOf('/ja') !== -1) return 'ja';
      if (path.indexOf('/ko') !== -1) return 'ko';
      if (path.indexOf('/ru') !== -1) return 'ru';
      if (path.indexOf('/tw') !== -1) return 'tw';
      if (path.indexOf('/th') !== -1) return 'th';
      return '';
    }
  },
  computed: {
    title() {
      switch (this.currentLang) {
        case 'en': return 'Pop Epoch - Rule Your Era, From Ice Age to Modern Marvels';
        case 'fr': return 'Préinscrivez-vous maintenant';
        case 'de': return 'Jetzt vorregistrieren';
        case 'es': return '¡Pre-regístrate ahora!';
        case 'pt': return 'Pré-cadastre-se Agora';
        case 'ja': return '今すぐ事前登録！';
        case 'ko': return '지금 예약하기';
        case 'ru': return 'Зарегистрируйтесь заранее';
        case 'tw': return '立即預約';
        case 'th': return 'ลงทะเบียนล่วงหน้าเลย';
        default: return window.location.href || this.$route.path;
      }
    },
    keywords() {
      switch (this.currentLang) {
        case 'en': return 'bonk,tribe,civilization,prosperity,pop,epoch,ice,valorant,global,survival,building,puzzle,history';
        case 'fr': return "Préinscription pour l'Histoire des Influenceurs";
        case 'de': return 'Influencer Story Vorregistrierung';
        case 'es': return 'Pre-registro de Influencer Story';
        case 'pt': return 'Pré-cadastro de Influencer Story ';
        case 'ja': return 'インフルエンサーストーリー事前登録';
        case 'ko': return '<인플루언서 스토리: 빛나는 여정> 사전 예약';
        case 'ru': return 'Предварительная регистрация на «Influencer Story»';
        case 'tw': return '《網紅故事》預先註冊';
        case 'th': return 'Influencer Story ลงทะเบียนล่วงหน้า';
        default: return window.location.href || this.$route.path;
      }
    },
    description() {
      switch (this.currentLang) {
        case 'en': return 'Embark on an epic journey in Pop Epoch! Start from the Ice Age and lead your tribe to greatness. Innovate, build, and strategize to evolve your civilization. Meet legends like Archimedes and Joan of Arc, harness technology, and command armies to dominate through the ages. Your legacy starts here - join now and shape history!';
        case 'fr': return 'Préinscrivez-vous dès maintenant pour recevoir des récompenses !';
        case 'de': return 'Jetzt vorregistrieren, um Belohnungen zu erhalten!';
        case 'es': return '¡Pre-regístrate ahora para recibir recompensas!';
        case 'pt': return 'Pré-cadastre-se Agora para receber recompensas!';
        case 'ja': return '事前登録して報酬をゲットしよう！';
        case 'ko': return '지금 예약하고 상품 받기!';
        case 'ru': return 'Зарегистрируйтесь заранее, чтобы получить награды!';
        case 'tw': return '立即預約，領取獎勵！';
        case 'th': return 'ลงทะเบียนล่วงหน้าตอนนี้ เพื่อรับรางวัล!';
        default: return window.location.href || this.$route.path;
      }
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: [
        { name: 'description', content: this.description },
        { name: 'keywords', content: this.keywords },
      ]
    };
  }
}

// 解决ios10及以上safari无法禁止缩放的问题
window.onload = function () {
  var lastTouchEnd = 0
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener(
    'touchend',
    function (event) {
      var now = new Date().getTime()
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    },
    false
  )
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
  document.addEventListener('dblclick', function (event) {
    event.preventDefault()
  })
}
</script>
<style lang="stylus">
html{
  background: #000000;
}
#app {
  overflow-x: hidden;
  overflow-y: hidden !important;
}

</style>
